import Alert from './Alert';
export default Alert;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-alert/src/index.js